export default "__VITE_ASSET__C1k0Nt8y__"